import { type RefObject, useEffect } from 'react';

interface UseSearchClickOutsideParams {
  containerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
}

/** Закрывает поиск по клику/тапу вне контейнера. */
export function useSearchClickOutside({
  containerRef,
  onClose,
}: UseSearchClickOutsideParams): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    const handleTouchStart = (event: TouchEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleTouchStart);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }, [containerRef, onClose]);
}
